import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import logo from '../assets/images/hey-visuals-logo.png';
import { Link, useNavigate } from 'react-router-dom';
import googlelogo from '../assets/media/svg/google.svg';
import GoogleSignInPage from './GoogleSignIn';
import { LoadingContext } from './LoadinContext';
const SignIn = () => {
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [errors, setErrors] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const { loadingGoogle } = useContext(LoadingContext);
    const navigate = useNavigate();
    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: '' });
    };

    const validateInputs = () => {
        let isValid = true;
        let errorMessages = { email: '', password: '' };
        if (!formData.email) {
            errorMessages.email = 'Email is required.';
            isValid = false;
        }
        if (!formData.password) {
            errorMessages.password = 'Password is required.';
            isValid = false;
        }
        setErrors(errorMessages);
        return isValid;
    };

    const isValidateInputs = () => {
        const {  email,  password } = formData;
        return (
          email.trim() &&
          password.trim() 
        );
      };

    const handleSignIn = async (e) => {
        e.preventDefault();
        localStorage.removeItem('errorGoogle');
        setErrorGoogle('');
        if (!validateInputs()) return;
        setLoading(true);
        try {
            const { email, password } = formData;
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/login`,
                { email, password }
            );
            if (response.data.status === 200) {
                localStorage.setItem('auth', JSON.stringify(response.data.auth));
                navigate('/');
            } else {
                handleApiErrors(response.data);
            }
        } catch (error) {
            setErrors({
                ...errors,
                password: error.response?.data?.message || 'An error occurred during login.',
            });
        } finally {
            setLoading(false);
        }
    };

    const handleApiErrors = (data) => {
        let apiErrors = { email: '', password: '' };
        if (data.status === 422) {
            apiErrors.email = data.message.email;
        } else if (data.status === 401) {
            apiErrors.password = 'Incorrect password.';
        }
        setErrors(apiErrors);
    };

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    
    const [errorGoogle, setErrorGoogle] = useState('');

    useEffect(() => {
        let isValid = true;
        const errorFromGoogle = localStorage.getItem('errorGoogle');
        if (errorFromGoogle) {
            setErrorGoogle(errorFromGoogle);
            isValid = false;
        }
        localStorage.removeItem('errorGoogle');
        return () => {
            setErrorGoogle('');
        };
    }, []);

    return (
        <div className="d-flex flex-column flex-lg-row flex-column-fluid" style={{ backgroundColor: '#F7F8FB', height: '100vh' }}>
            {/* Left Section */}
            <div className="d-flex flex-lg-row-fluid w-50">
                <div className="d-none d-md-flex flex-column flex-center pb-0 w-100">
                    <img className="theme-light-show w-250px mx-auto pb-10" src={logo} alt="Hey Visuals Logo" />
                    <section className="HomeVideoSection">
                        <div className="HomeVideoOuter">
                            <div className="video-wrapper">
                                <div className="wistia_responsive_padding" style={{ padding: "56.25% 0 0 0", position: "relative" }}>
                                    <div className="wistia_responsive_wrapper" style={{ height: "100%", left: "0", position: "absolute", top: "0", width: "100%" }}>
                                        <iframe
                                            src="https://fast.wistia.net/embed/iframe/dajig0c7nu?seo=true&videoFoam=true"
                                            title="How Hey Visuals AI Works?"
                                            allow="autoplay; fullscreen"
                                            frameBorder="0"
                                            scrolling="no"
                                            className="wistia_embed"
                                            name="wistia_embed"
                                            style={{ width: "100%", height: "100%" }}
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>

            {/* Right Section */}
            <div className="d-flex flex-column-fluid flex-lg-row-auto justify-content-center justify-content-lg-end p-md-12 p-10" style={{ height: '100vh' }}>
                <div className="bg-body-md d-flex flex-column flex-center rounded-4 widthAdj p-md-10">
                    <div className="bg-body-sm d-flex flex-center flex-column rounded-4 h-lg-100 w-md-400px p-md-0 p-7">
                        <img className="d-md-none theme-light-show mb-3 w-75" src={logo} alt="Hey Visuals Logo" />

                        {/* Sign-in Form */}
                        <form className="form w-100" noValidate onSubmit={handleSignIn} id="login-form">
                            <div className="text-center mb-11">
                                <h1 className="text-dark fw-bolder mb-3">Sign In</h1>
                                <div className="text-gray-500 fw-semibold fs-6">
                                    Your Social Campaigns
                                </div>
                            </div>

                            {/* Social Buttons */}
                            <div className=" mb-4">
                                <GoogleSignInPage className="w-100" />
                            </div>

                            <div className="separator separator-content my-8">
                                <span className="w-125px text-gray-500 fw-semibold fs-7">Or with email</span>
                            </div>

                            <div className="fv-row mb-8">
                                <input
                                    type="email"
                                    placeholder="Email"
                                    name="email"
                                    className={`form-control bg-transparent login-email-inp ${errors.email ? 'is-invalid' : ''} ${errorGoogle ? 'is-invalid' : ''}`}
                                    value={formData.email}
                                    onChange={handleInputChange}
                                    required
                                />
                                {errorGoogle && (
                                    <div className="error-message text-danger">
                                        {errorGoogle}
                                    </div>
                                )}
                                <span className="text-danger small">{errors.email}</span>
                            </div>

                            <div className="fv-row mb-3" style={{ position: 'relative' }}>
                                <input
                                    type={showPassword ? 'text' : 'password'}
                                    placeholder="Password"
                                    name="password"
                                    className={`form-control bg-transparent login-password-inp ${errors.password ? 'is-invalid' : ''}`}
                                    value={formData.password}
                                    onChange={handleInputChange}
                                    required
                                />
                                <div style={{ position: 'absolute', right: '15px', top: '6px', cursor: 'pointer' }}>
                                    <i
                                        className={`bi bi-eye-slash fs-4 text-muted ${showPassword ? 'd-none' : ''}`}
                                        onClick={togglePasswordVisibility}
                                    ></i>
                                    <i
                                        className={`bi bi-eye fs-4  text-primary ${showPassword ? '' : 'd-none'}`}
                                        onClick={togglePasswordVisibility}
                                    ></i>
                                </div>
                                <span className="text-danger small">{errors.password}</span>
                            </div>

                            <div className="d-flex flex-end flex-wrap gap-3 fs-base fw-semibold mb-8">
                                <Link to="/resetpassword" className="link-primary">Forgot Password?</Link>
                            </div>

                            <div className="d-grid mb-10">
                                <button
                                    type="submit"
                                    className="btn btn-theme btn-shadow login-btn"
                                    disabled={loading || loadingGoogle || !isValidateInputs()}>
                                    {loading || loadingGoogle ? (
                                        loadingGoogle ? (
                                            <>
                                                Please wait...{' '}
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </>
                                        ) : (
                                            <>
                                                Signing in...{' '}
                                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                            </>
                                        )
                                    ) : (
                                        'Sign In'
                                    )}
                                </button>
                            </div>

                            <div className="text-gray-500 text-center fw-semibold fs-6">
                                Not a Member yet? <Link to="/register" className="link-primary">Sign up</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignIn;
